import React from 'react';

import { Card, Grid } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    BulkEditionMenu,
    InputSearch,
    StatusFilterSelect,
} from 'common/components';

const BulkOperationsCard = ({
    filterData,
    handleClickBulkItems,
    handleOnChangeSearch,
    handleOnSelectStatus,
    prefix,
    selectedBulkOption,
    selectionModel,
    setSelectedBulkOption,
    setSelectionModel,
}) => {
    const { t } = useTranslation();

    const isArchivedList = filterData?.status === 'archived';
    const callback = () => {
        setSelectedBulkOption('');
        setSelectionModel([]);
    };

    return (
        <Card>
            <Card.Body>
                <Grid container alignItems="end" justifyContent="flex-end">
                    <Grid
                        size={{
                            lg: isEmpty(selectionModel) ? 15 : 11,
                            md: isEmpty(selectionModel) ? 13 : 7,
                            xs: 18,
                        }}
                    >
                        <InputSearch
                            onChange={handleOnChangeSearch}
                            placeholder={t('Search')}
                            value={filterData?.searchText}
                        />
                    </Grid>

                    <Grid size={{ lg: 3, md: 5, xs: 18 }}>
                        <StatusFilterSelect
                            filterBy={filterData?.status}
                            handleSelected={handleOnSelectStatus}
                            variant="standard"
                        />
                    </Grid>

                    {!isEmpty(selectionModel) && (
                        <Grid size={{ lg: 4, md: 9, xs: 18 }}>
                            <BulkEditionMenu
                                items={[
                                    {
                                        label: t('Archive'),
                                        handleClick: () =>
                                            handleClickBulkItems(
                                                selectionModel,
                                                'archived',
                                                filterData,
                                                callback,
                                            ),
                                        visible: !isArchivedList,
                                    },
                                    {
                                        label: t('Unarchive'),
                                        handleClick: () =>
                                            handleClickBulkItems(
                                                selectionModel,
                                                'active',
                                                filterData,
                                                callback,
                                            ),
                                        visible: isArchivedList,
                                    },
                                    {
                                        label: t('Delete'),
                                        handleClick: () =>
                                            handleClickBulkItems(
                                                selectionModel,
                                                'deleted',
                                                filterData,
                                                callback,
                                            ),
                                        visible: isArchivedList,
                                    },
                                ]}
                                prefix={prefix}
                                selectedBulkOption={selectedBulkOption}
                                selectionModel={selectionModel}
                                setSelectedBulkOption={setSelectedBulkOption}
                                setSelectionModel={setSelectionModel}
                            />
                        </Grid>
                    )}
                </Grid>
            </Card.Body>
        </Card>
    );
};

BulkOperationsCard.propTypes = {
    filterData: PropTypes.object,
    handleClickBulkItems: PropTypes.func,
    handleOnChangeSearch: PropTypes.func,
    handleOnSelectStatus: PropTypes.func,
    prefix: PropTypes.string,
    selectedBulkOption: PropTypes.string,
    selectionModel: PropTypes.array,
    setSelectedBulkOption: PropTypes.func,
    setSelectionModel: PropTypes.func,
};

export default BulkOperationsCard;
